import Modal from './container'

export default Modal



// WEBPACK FOOTER //
// ./src/legacy/containers/Modal/index.js